<template>
    <adminTable ref="adminTableRef" :tableLoading="tableLoading" :totalList="totalList" v-model:page="page"
        v-model:limit="limit" v-model:searchForm="searchForm" :tableData="tableData" @search="getList">
        <template v-slot:form-inline-items>
            <el-form-item>
                <el-input v-model="searchForm.keyword" placeholder="搜索股权名称关键字" clearable />
            </el-form-item>
            <el-form-item>
                <el-input v-model="searchForm.username" placeholder="搜索用户" clearable />
            </el-form-item>
            <el-form-item>
                <el-input v-model="searchForm.phone" placeholder="搜索手机号" clearable />
            </el-form-item>
            <el-form-item>
                <el-select
                    v-model="searchForm.is_test"
                    placeholder="账号类型"
                    clearable
                >
                    <el-option
                        v-for="item in accountTypeEnums"
                        :label="item.label"
                        :value="item.value"
                        :key="item.label"
                    />
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-col :span="11">
                    <el-date-picker v-model="searchForm.starttime" type="datetime" value-format="YYYY-MM-DD HH:mm:ss"
                        placeholder="开始时间" style="width: 100%" />
                </el-col>
                <el-col :span="2" class="text-center">
                    <span class="text-gray-500">-</span>
                </el-col>
                <el-col :span="11">
                    <el-date-picker v-model="searchForm.endtime" type="datetime" value-format="YYYY-MM-DD HH:mm:ss"
                        placeholder="结束时间" style="width: 100%" />
                </el-col>
            </el-form-item>
           
           <div style="width: 100%; display: flex; justify-content: flex-start;">
                <el-form-item>
                    做多总和: <el-input v-model="statistics.long_total" placeholder="做多总和" disabled style="width: 150px;" />
                </el-form-item>
                <el-form-item>
                    做空总和: <el-input v-model="statistics.short_total" placeholder="做空总和" disabled style="width: 150px;" />
                </el-form-item>
            </div>
           
        </template>
        <template v-slot:table>
            <el-table-column prop="id" label="ID" width="60">
                <template #default="scope">
                    <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
                        {{ scope.row.id }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="code" label="股权编码" width="160">
                <template #default="scope">
                    <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
                        {{ scope.row.stock?.code }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="name" label="股权名称" width="150">
                <template #default="scope">
                    <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
                        {{ scope.row.stock?.name }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="username" label="用户名" width="140">
                <template #default="scope">
                    <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
                        {{ scope.row.user?.username }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="phone" label="手机号" width="140">
                <template #default="scope">
                    <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
                        {{ scope.row.user?.phone }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="side" label="类型" width="80">
                <template #default="scope">
                    <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
                        {{ getLabelByVal(scope.row.side, stocksSideEnums) }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="num" label="持仓数量" width="120">
                <template #default="scope">
                    <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
                        {{ scope.row.num }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="original_num" label="原始股数量" width="120">
                <template #default="scope">
                    <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
                        {{ scope.row.original_num }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="purchase_time" label="购入时间" width="180">
                <template #default="scope">
                    <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
                        {{ scope.row.purchase_time }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="updated_at" label="更新时间" width="180">
                <template #default="scope">
                    <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
                        {{ scope.row.updated_at }}
                    </span>
                </template>
            </el-table-column>
        </template>
    </adminTable>
</template>

<script setup>
import { ref, getCurrentInstance, onMounted } from "vue";
import { getTokenAUTH } from "@/utils/auth";
import { stocksSideEnums, getLabelByVal, accountTypeEnums } from "@/config/enums";

const searchForm = ref({
    keyword: "",
    username: '',
    phone: '',
    is_test: '',
    starttime: '',
    endtime: '',
});
const adminTableRef = ref(null);
const headers = ref({})

onMounted(() => {
    headers.value['Accept-Token'] = getTokenAUTH()
    getList();
});

const { proxy } = getCurrentInstance();

const tableData = ref([]);
const page = ref(1);
const limit = ref(10);
const totalList = ref(0);
const tableLoading = ref(false);
const statistics = ref({
    long_total: 0,
    short_total: 0,
});

const getList = async () => {
    tableLoading.value = true;
    const res = await proxy.$http({
        type: "get",
        url: "/Stock/getActiveStockLists",
        params: {
            page: page.value,
            limit: limit.value,
            ...searchForm.value,
        },
    });
    tableLoading.value = false;
    if (res.code == 0) {
        tableData.value = res.data.data;
        totalList.value = res.data.total;
        statistics.value.long_total = res.data.long_total || 0;
        statistics.value.short_total = res.data.short_total || 0;
    }
};
</script>

<style lang="less" scoped></style>

